import { IconButton } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { SettingsIcon } from '@blocksuite/icons/rc';

import * as styles from './sidebar-footer.css';
import UserInfo from './user-info';

/**
 * Pinned to the bottom of the sidebar card.
 * Left: the user's avatar with name and plan badge (or sign-in).
 * Right: settings.
 */
export const SidebarFooter = ({
  onOpenSettings,
  onOpenImport,
}: {
  onOpenSettings: () => void;
  onOpenImport: () => void;
}) => {
  const t = useI18n();

  return (
    <div className={styles.footer}>
      <UserInfo onOpenImport={onOpenImport} />
      <IconButton
        size="20"
        className={styles.footerButton}
        data-testid="slider-bar-workspace-setting-button"
        tooltip={t['com.affine.settingSidebar.title']()}
        tooltipOptions={{ side: 'top' }}
        onClick={onOpenSettings}
      >
        <span data-testid="settings-modal-trigger" className={styles.iconSlot}>
          <SettingsIcon />
        </span>
      </IconButton>
    </div>
  );
};
